// objects.service.ts
import { http } from "../http";
import type { AxiosResponse } from "axios";
import type { ApiObject } from "@/models/api";

export const deleteUser = async (
  id: number
): Promise<AxiosResponse<ApiObject>> => {
  const response = await http.delete<ApiObject>(`items/id/${id}`);
  return response;
};
